import './Resources.css';

import {useEffect, useState} from 'react';

const toolboxTalks = [
  {
    id: 1,
    title: 'Toolbox Talk #1',
    pdfUrl: '/pdfs/toolbox-talk-1.pdf',
  },
  {
    id: 2,
    title: 'Toolbox Talk #2',
    pdfUrl: '/pdfs/toolbox-talk-2.pdf',
  },
  {
    id: 3,
    title: 'Toolbox Talk #3',
    pdfUrl: '/pdfs/toolbox-talk-3.pdf',
  },
  {
    id: 4,
    title: 'Toolbox Talk #4',
    pdfUrl: '/pdfs/toolbox-talk-4.pdf',
  },
  {
    id: 5,
    title: 'Toolbox Talk #5',
    pdfUrl: '/pdfs/toolbox-talk-5.pdf',
  },
  {
    id: 6,
    title: 'Toolbox Talk #6',
    pdfUrl: '/pdfs/toolbox-talk-6.pdf',
  },
  {
    id: 7,
    title: 'Toolbox Talk #7',
    pdfUrl: '/pdfs/toolbox-talk-7.pdf',
  },
  {
    id: 8,
    title: 'Toolbox Talk #8',
    pdfUrl: '/pdfs/toolbox-talk-8.pdf',
  },
  {
    id: 9,
    title: 'Toolbox Talk #9',
    pdfUrl: '/pdfs/toolbox-talk-9.pdf',
  },
  {
    id: 10,
    title: 'Toolbox Talk #10',
    pdfUrl: '/pdfs/toolbox-talk-10.pdf',
  },
];

const Resources = () => {
  const [selectedTalk, setSelectedTalk] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleTalkClick = (talk) => {
    setSelectedTalk(talk);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedTalk(null);
  };

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === 'Escape') {
        closeModal();
      }
    };

    if (showModal) {
      document.addEventListener('keydown', handleEscapeKey);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
      document.body.style.overflow = 'unset';
    };
  }, [showModal]);

  return (
    <div className='resources-container'>
      <div className='resources-header'>
        <h1>Tenvos AI Resource Center</h1>
      </div>

      <div className='toolbox-talks-grid'>
        {toolboxTalks.map((talk) => (
          <button
            key={talk.id}
            className='toolbox-talk-button'
            onClick={() => handleTalkClick(talk)}
          >
            <div className='talk-title'>{talk.title}</div>
          </button>
        ))}
      </div>

      {showModal && selectedTalk && (
        <div className='modal-overlay' onClick={closeModal}>
          <div className='modal-content' onClick={(e) => e.stopPropagation()}>
            <div className='modal-header'>
              <h2>{selectedTalk.title}</h2>
              <button
                className='close-button'
                onClick={closeModal}
                aria-label='Close'
              >
                ×
              </button>
            </div>

            <div className='modal-body'>
              <iframe
                src={selectedTalk.pdfUrl}
                title={selectedTalk.title}
                className='pdf-viewer'
                type='application/pdf'
              >
                <p>
                  Your browser does not support PDFs.
                  <a
                    href={selectedTalk.pdfUrl}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    Download the PDF
                  </a>
                </p>
              </iframe>
            </div>

            <div className='modal-footer'>
              <a
                href={selectedTalk.pdfUrl}
                target='_blank'
                rel='noopener noreferrer'
                className='download-link'
              >
                Open in New Tab
              </a>
              <button className='close-modal-button' onClick={closeModal}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Resources;
